<app-breadcrumb [title]="'Criterios de Comportamiento SV'" [items]="['Responsabilidad y Comportamiento Seguro']"
    [active_item]="'Criterios de Comportamiento'"></app-breadcrumb>

<div class="container-fluid programa-form-wrap">
    <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white d-flex align-items-center">
            <i class="icofont icofont-checked me-2"></i>
            <h5 class="mb-0"><strong>CRITERIOS DE EVALUACIÓN DE COMPORTAMIENTO</strong></h5>
        </div>

        <div class="card-body">
            <ul ngbNav #criterioTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

                <li [ngbNavItem]="1">
                    <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO CRITERIO</strong></a>
                    <ng-template ngbNavContent>
                        <form [formGroup]="criterioForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
                            <div class="card border-0 shadow-sm mb-3">
                                <div class="card-body">
                                    <div class="row g-3">
                                        <div class="col-md-12">
                                            <label class="form-label fw-semibold">Criterio: <span class="text-danger">*</span></label>
                                            <textarea class="form-control text-uppercase" formControlName="criterio"
                                                placeholder="Ej. Cumple las normas de tránsito"
                                                [class.is-invalid]="criterioForm.get('criterio')?.invalid && criterioForm.get('criterio')?.touched"></textarea>
                                            <div class="invalid-feedback"
                                                *ngIf="criterioForm.get('criterio')?.invalid && criterioForm.get('criterio')?.touched">
                                                El criterio es obligatorio.
                                            </div>
                                        </div>

                                        <div class="col-md-8">
                                            <label class="form-label fw-semibold">Descripción (opcional):</label>
                                            <textarea class="form-control" formControlName="descripcion"
                                                placeholder="Detalle del criterio..."></textarea>
                                        </div>

                                        <div class="col-md-4">
                                            <label class="form-label fw-semibold">Peso (%):</label>
                                            <input type="number" min="0" max="100" class="form-control" formControlName="peso"
                                                placeholder="Ej. 20">
                                            <small class="text-secondary">Déjelo vacío para ponderación uniforme.</small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center gap-2 mt-4">
                                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                                    <span *ngIf="!guardando">
                                        <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                                    </span>
                                    <span *ngIf="guardando">
                                        <span class="spinner-border spinner-border-sm me-1"></span>
                                        {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
                                    </span>
                                </button>
                                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion"
                                    (click)="cancelarEdicion()" [disabled]="guardando">
                                    <i class="icofont icofont-close me-1"></i>Cancelar edición
                                </button>
                            </div>
                        </form>
                    </ng-template>
                </li>

                <li [ngbNavItem]="2">
                    <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO CRITERIOS</strong></a>
                    <ng-template ngbNavContent>
                        <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
                            <div class="card-body pt-3">
                                <div *ngIf="cargandoListado" class="text-center py-4">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <p class="mt-2 mb-0">Cargando criterios...</p>
                                </div>

                                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                                    <div class="col-md-3">
                                        <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                                            <option [ngValue]="null">Todos</option>
                                            <option [ngValue]="1">Activos</option>
                                            <option [ngValue]="0">Inactivos</option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 ms-auto">
                                        <div class="input-group">
                                            <input type="text" class="form-control" placeholder="Buscar criterio..."
                                                [(ngModel)]="filtro" (input)="aplicarFiltro()" />
                                            <span class="input-group-text"><i class="fa fa-search"></i></span>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                                    <ng-container *ngIf="criteriosFiltrados?.length > 0; else sinDatos">
                                        <table id="tblCriteriosComportamiento" class="table table-bordered table-hover align-middle">
                                            <thead class="bg-primary text-white">
                                                <tr>
                                                    <th class="text-center">CRITERIO</th>
                                                    <th class="text-center">PESO (%)</th>
                                                    <th class="text-center">ESTADO</th>
                                                    <th class="text-center">ACCIONES</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of criteriosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                                                    <td class="text-center">{{ item.criterio || '-' }}</td>
                                                    <td class="text-center">{{ item.peso ?? '-' }}</td>
                                                    <td class="text-center">
                                                        <span class="badge rounded-pill"
                                                            [ngClass]="Number(item.estado) === 1 ? 'bg-success' : 'bg-secondary'">
                                                            {{ Number(item.estado) === 1 ? 'ACTIVO' : 'INACTIVO' }}
                                                        </span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="d-flex justify-content-center gap-1">
                                                            <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) === 1" ngbTooltip="Editar"
                                                                (click)="editarCriterio(item)">
                                                                <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) === 1" ngbTooltip="Inactivar"
                                                                (click)="cambiarEstado(item, 0)">
                                                                <i class="icofont icofont-close" style="font-size: .85rem;"></i>
                                                            </button>
                                                            <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                                *ngIf="Number(item.estado) !== 1" ngbTooltip="Activar"
                                                                (click)="cambiarEstado(item, 1)">
                                                                <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div class="d-flex justify-content-between align-items-center mt-4">
                                            <div class="d-flex align-items-center">
                                                <label class="me-2">Mostrar:</label>
                                                <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                                                    <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                                                </select>
                                                <span class="ms-2">registros por página</span>
                                            </div>
                                            <div class="text-center flex-grow-1">
                                                Total Registros: <a class="badge badge-primary"><b>{{ criteriosFiltrados?.length || 0 }}</b></a>
                                            </div>
                                            <div class="text-end paginador-personalizado">
                                                <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                                                    [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                                            </div>
                                        </div>

                                        <div class="mt-4">
                                            <div class="btn-showcase text-center">
                                                <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                                                    (click)="exportarExcel('tblCriteriosComportamiento','listado_criterios_comportamiento')">
                                                    <i class="icofont icofont-file-excel"></i> EXCEL
                                                </button>
                                                <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                                                    (click)="exportToPDF('tblCriteriosComportamiento','listado_criterios_comportamiento','Listado de criterios de comportamiento')">
                                                    <i class="icofont icofont-file-pdf"></i> PDF
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-template #sinDatos>
                                        <div class="text-center py-4 text-primary">No hay criterios registrados.</div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </li>
            </ul>

            <div [ngbNavOutlet]="criterioTab" class="mt-2"></div>
        </div>
    </div>
</div>